import { WalletSlice } from '../types/wallet-slice.type';
import { useWalletStore } from './useWalletStore';

export function useSuiWallet(): WalletSlice {
	return useWalletStore((state) => state.suiWallet);
}
